module.exports = __webpack_public_path__ + "img/66.a7f51437.jpg";